export default __webpack_public_path__ + "static/media/waiting.c2417755.png";